import { GET } from "../API/get";

const buildQuery = (params = {}) => {
    const query = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            query.append(key, value);
        }
    });

    const queryString = query.toString();
    return queryString ? `?${queryString}` : "";
};

export const fetchFinancialStatistics = async (ftm_id, dataFilter = {}) => {
    const query = buildQuery({
        start_date: dataFilter?.startDate,
        end_date: dataFilter?.endDate,
        ftm_id
    });

    const response = await GET(`v3/financial/statistics${query}`);
    return response?.status === "Success" ? response : null;
};

export const fetchFinancialJobs = async (page, ftm_id, dataFilter = {}, ftm_payment_filter = undefined) => {
    const query = buildQuery({
        start_date: dataFilter?.startDate,
        end_date: dataFilter?.endDate,
        ftm_id,
        ftm_payment_filter
    });

    const response = await GET(`v3/financial/${page}${query}`);
    return response?.status === "Success" ? response : null;
};

export const fetchFtmsList = async () => {
    const response = await GET(`v3/ftms/dropdown`);
    return response?.status === "Success" ? response : null;
};